import React, { Fragment } from "react";

// Declarations
const FRESHWORKS_WIDGET_ID = 84000000919;

class FreshWorksWidget extends React.Component {
  _insertScript = scriptText => {
    const script = document.createElement("script");
    script.innerText = scriptText;
    script.async = true;
    document.body.appendChild(script);
    setTimeout(() => {
      this.props.onChatLoad();
    }, 2000);
  };

  _addMainScript = () => {
    const scriptText = `
    window.fwSettings = {
      widget_id: ${FRESHWORKS_WIDGET_ID},
    };
    !(function () {
      if (typeof window.FreshworksWidget !== "function") {
        var n = function () {
          n.q.push(arguments);
        };
        (n.q = []), (window.FreshworksWidget = n);
      }

      const o = document.createElement("script");
      (o.type = "text/javascript"),
        (o.async = !0),
        (o.crossorigin = "anonymous"),
        (o.src = "https://ind-widget.freshworks.com/widgets/${FRESHWORKS_WIDGET_ID}.js");
      const i = document.getElementsByTagName("script")[0];
      i.parentNode.insertBefore(o, i);
    })();
    `;

    this._insertScript(scriptText);
  };

  componentDidMount() {
    if (typeof window !== "undefined" && !window.FreshworksWidget) {
      this._addMainScript();
    }
  }

  render() {
    return <Fragment />;
  }
}

export default FreshWorksWidget;
